<template>
    <div class="curtain-grey" :style="{backgroundColor: categoryState ? 'rgba(0, 0, 0, 0)':'rgba(0, 0, 0, 0.2)'}">
        <CategoryManage v-if="categoryState"
                        @closeEvent="switchState"/>
        <div class="body-option-category" v-show="!categoryState">
            <div class="border-option-category">
                <div class="text-title">选择分类</div>
                <ul class="items-category scrollbar">
                    <li class="item-category my-cursor"
                        @click.stop="selected({categoryId: '', title: ''})">
                        <div :class="{
                            'icon-option-true': '' === categoryItem.categoryId,
                            'icon-option-false': '' !== categoryItem.categoryId,
                        }">
                        </div>
                        <div class="text-category">无分类</div>
                    </li>

                    <li class="item-category my-cursor"
                        @click.stop="selected(item)"
                        v-for="item in tbListCategory">

                        <div :class="{
                        'icon-option-true': item.categoryId === categoryItem.categoryId,
                        'icon-option-false': item.categoryId !== categoryItem.categoryId,
                    }"></div>
                        <div class="text-category">{{ item.title }}</div>
                    </li>
                </ul>
                <div class="category-manage my-cursor" @click.stop="switchState">
                    分类管理
                </div>
                <div class="button-items">
                    <div class="button-close my-cursor" @click.stop="close">取消</div>
                    <div class="button-submit my-cursor" @click.stop="submit">保存</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CategoryManage from "../CategoryManage";
import { mapState, mapMutations } from "vuex";

export default {
    name: "OptionCategory",
    components: {
        CategoryManage
    },
    data(){
        return {
            categoryState: false,
            categoryItem: {},
        }
    },
    computed: {
        ...mapState(["userId"]),
        ...mapState("listModules", {
            tbListCategory: state => state.tbListCategory,
            optId: state => state.optId,
        }),
    },
    props: {
        categoryId: {
            type: String,
            default: "",
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent", this.categoryItem);
            this.close();
        },
        selected: function(categoryItem){
            this.categoryItem = categoryItem;
        },
        switchState: function(){
            this.categoryState = !this.categoryState;
        },
    },
    created(){
        this.categoryItem.categoryId = this.categoryId;
    },
}
</script>

<style scoped>
div.body-option-category{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}

div.border-option-category{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
ul.items-category{
    width: 100%;
    max-height: 2rem;

    overflow-y: scroll;
    margin-top: 0.1rem;
    margin-bottom: 0.1rem;
}
ul.scrollbar::-webkit-scrollbar{
    background: transparent;
}
li.item-category{
    width: 100%;
    height: 0.4rem;
    display: flex;
    align-items: center;
    gap: 0.1rem;
}
div.icon-option-true, div.icon-option-false{
    width: 0.22rem;
    height: 0.22rem;

}
div.icon-option-true{
    background: url("../../../assets/images/Public/icon-option-true.png");
    background-size: cover;
}
div.icon-option-false{
    background: url("../../../assets/images/Public/icon-option-false.png");
    background-size: cover;
}
div.text-category{
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: left;
}
div.category-manage{
    width: 100%;
    height: 0.42rem;
    background: rgba(254, 228, 148, 0.5);
    border-radius: 0.1rem;

    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: center;
    line-height: 0.42rem;
}
div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    padding: 0 0.34rem;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>